// NOTICE: This file was copied from the oppizi-shared repository, do
// not modify it here.

import { objectWithoutUndefined } from '../../libraries/utils/object'

/**
 * This function will merge persisted conversations with fresh conversations and filter out outdated ones
 *
 * @param {<Object>} persistedConversations - Persisted conversations from redux state
 * @param {Array<Object>} newConversations - Fetched conversations
 * @param {Array<String>} validConversationsIds - IDs of the valid conversations
 */

export const mergeConversations = ({
  persistedConversations,
  newConversations,
  validConversationsIds,
}) => {
  return [...Object.values(persistedConversations), ...newConversations].reduce(
    (acc, conversation) => {
      const {
        id,
        name,
        lastReadTime,
        archived,
        isCityBased,
        lastStaffReadTime,
        participantsIds,
        cityBasedCityIds,
        missionId,
      } = conversation

      if (
        validConversationsIds.includes(id) ||
        !validConversationsIds ||
        !validConversationsIds.length
      ) {
        acc[id] = Object.assign(
          { orderedMessages: [] },
          persistedConversations[id],
          objectWithoutUndefined({
            id,
            name,
            lastReadTime,
            archived,
            isCityBased,
            lastStaffReadTime,
            participantsIds,
            cityBasedCityIds,
            missionId,
          }),
        )
      }

      return acc
    },
    {},
  )
}

export const getConversationsByMissionIds = conversations => {
  return Object.values(conversations).reduce((acc, conv) => {
    if (conv.missionId) {
      acc[conv.missionId] = conv
    }

    return acc
  }, {})
}
